<template>
  <div>
    <!-- Add/Update Admin Form START -->
    <v-dialog persistent v-model="adminActionsModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitForm)">
            <v-card-text class="align-center">
              <ValidationProvider
                :name="'Başlık'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Title"
                  label="Başlık"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'Açıklama'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Description"
                  label="Açıklama"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'Sicil'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Username"
                  label="Sicil"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'Pozisyon'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Position"
                  label="Pozisyon"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'Fotoğraf'"
                :rules="isUpdate ? '' : 'required'"
                v-slot="{ errors }"
              >
                <v-file-input
                  v-model="form.photoFile"
                  label="Fotoğraf Yükle"
                  outlined
                  :error-messages="errors[0]"
                  accept="image/*"
                ></v-file-input>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                small
                class="ma-2 mr-4"
                type="submit"
                elevation="0"
                large
                outlined
                color="red"
              >
                {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
              </v-btn>
              <v-btn
                small
                class="ma-2 mr-4"
                elevation="0"
                large
                outlined
                color="grey"
                @click="adminActionsModal = false"
              >
                {{ $t("buttons.cancel") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Add/Update Admin Form END -->

    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{ $t("navigationDrawerMenu.newcomers") }}</v-col>
          <v-spacer />
          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="
              isUpdate = false;
              adminActionsModal = true;
            "
          >
            {{ $t("buttons.add") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-row justify="end">
          <!-- <v-col cols="3">
            <v-text-field
              v-model="sicilNumber"
              label="Sicil Numarası"
              clearable
              @keyup.enter="getItems"
            />
          </v-col> -->
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            />
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="$store.state.loadingStatus"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- Fotoğrafı göstermek için örnek slot -->
          <template v-slot:item.PhotoFileId="{ item }">
            <v-avatar v-if="item.PhotoFileId" size="36">
              <v-img :src="getImageURL(item.PhotoFileId)" alt="" />
            </v-avatar>
          </template>

          <template v-slot:item.CreatedAt="{ item }">
            {{ formatDate(item.CreatedAt) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="
                    adminActionsModal = true;
                    changeActiveEvent(item, true);
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDeleteModal(item.Id)"
                  v-bind="attrs"
                  v-on="on"
                  color="error"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div v-if="pages > 0" class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CompanySelect from "../components/CompanySelect.vue";
import DeleteModal from "../components/General/DeleteModal";
import UpdatePassword from "../components/UpdatePassword.vue";
import FileService from "../services/FileService";
import NewcomersService from "../services/NewcomersService";
import { formatDate } from "../utils/common";

export default {
  data: () => ({
    sicilNumber: "",
    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],

    //Pagination models
    pagination: {
      totalItems: 200,
      rowsPerPage: 15,
      page: 1,
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],

    form: {
      Title: "",
      Description: "",
      Username: "",
      PhotoFileId: null,
      Position: "",
      photoFile: null,
    },
    adminActionsModal: false,
    isUpdate: false,
    deleteId: null,
  }),

  watch: {
    adminActionsModal(newValue) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  mounted() {
    FileService.getFile(10009)
    this.setup();
    this.getItems();
  },
  components: {
    DeleteModal,
    UpdatePassword,
    CompanySelect,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
  },

  methods: {
    getImageURL(fileId){
      if(!fileId) return "https://tcap.pbworks.com/f/1435170280/myAvatar.png"
      return FileService.getFileString(fileId);
    },
    formatDate(date){
      return formatDate(date);
    },
    setup() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.headers = [
        { text: "Ad Soyad", value: "Title", sortable: false, align: "center" },
        {
          text: "Açıklama/Tanıtım",
          value: "Description",
          sortable: false,
          align: "center",
        },
        {
          text: "Sicil",
          value: "Username",
          sortable: false,
          align: "center",
        },
        {
          text: "Pozisyon",
          value: "Position",
          sortable: false,
          align: "center",
        },
        {
          text: "Fotoğraf",
          value: "PhotoFileId",
          sortable: false,
          align: "center",
        },
        {
          text: "Oluşturulma Tarihi",
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },
        {
          text: "İşlemler",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ];
    },

    getItems() {
      this.$store.state.loadingStatus = true;
      NewcomersService.getNewcomers(
        this.pagination.page,
        this.pagination.rowsPerPage,
      )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.tableData = data?.Data || [];
            this.pagination.totalItems = data.TotalData;
          }
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Change active event for click actions.
     * @param {any} item
     * @param {boolean} isUpdate
     */
    changeActiveEvent(item, isUpdate = false) {
      this.form = Object.assign(
        {
          Title: "",
          Description: "",
          Username: "",
          PhotoFileId: null,
          Position: "",
          photoFile: null,
        },
        item,
      );
      this.isUpdate = isUpdate;
    },

    async submitForm() {
      this.$store.state.loadingStatus = true;
      console.log(this.form.photoFile)
      try {
        let photoFileId = this.form.PhotoFileId;

        if (this.form.photoFile) {
          const formData = new FormData();
          formData.append("Files", this.form.photoFile)
          formData.append("Type", 1)
          const { data } = await FileService.uploadFile(formData);
          
          if(Array.isArray(data) && data.length > 0){
            photoFileId = data[0]?.Id || this.form.PhotoFileId;
          }
        }
        else if(!this.isUpdate){
          return;
        }
        
        const payload = {
          Title: this.form.Title,
          Description: this.form.Description,
          Username: this.form.Username,
          PhotoFileId: photoFileId,
          Position: this.form.Position,
        };

        if(this.isUpdate) payload.Id = this.form.Id; 

        await NewcomersService[`${this.isUpdate ? 'update' : 'add'}Newcomer`](payload);
        this.getItems();
        this.adminActionsModal = false;
        window.showSuccess(
          this.$t(
            `messages.${
              this.isUpdate ? "updatedSuccessfully" : "addedAdminSuccessfully"
            }`,
          ),
        );
      } catch (e) {
        window.showError(e);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },

    reset() {
      this.form = {
        Title: "",
        Description: "",
        Username: "",
        PhotoFileId: null,
        Position: "",
        photoFile: null,
      };
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },

    openDeleteModal(id) {
      this.deleteId = id;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    //Delete operation
    deleteItem() {
      this.$store.state.loadingStatus = true;
      NewcomersService.deleteNewcomer(this.deleteId)
        .then(() => {
          this.reset();
          window.showSuccess(
            this.$t("messages.deletedSuccessfully"),
            "standart",
            "info",
          );
          this.getItems();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getItems();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getItems();
    },
  },
};
</script>
